function forms() {
    /*=======
    Настраиваем проверку инпутов и ajax для формы обратной связи
    =======*/
    const form = document.querySelector('.form');

    if(form) {
        //Находим инпуты в форме
        const inputName = document.querySelector('#name');
        const inputPhone = document.querySelector('#phone');

        //Проверяем инпуты в процессе заполнения на кол-во символов
        function checkLength () {
            const nameVal = inputName.value.length;
            const phoneVal = inputPhone.value.length;

            //Если инпут имя и телефон соответствую условиям, удаляем класс ошибки
            if (nameVal >= 2) inputName.classList.remove('error');
            if (phoneVal >= 2) inputPhone.classList.remove('error');
        }

        // Используем регулярное выражение для удаления всех символов, кроме цифр и "+" в телефоне
        function checkNum () {
            let cleanedValue = inputPhone.value.replace(/[^0-9+]/g, '');
            // Обновляем значение в поле ввода
            inputPhone.value = cleanedValue;
        }

        //Вызываем функцию проверки
        inputName.addEventListener('input', checkLength);
        inputPhone.addEventListener('input', function() {
            checkLength();
            checkNum();
        });


        //Находим форму и значение атрибута action для ajax
        const action = form.getAttribute('action');

        form.addEventListener('submit', (e) => {
            // Отключаем стандартное поведение формы
            e.preventDefault();

            form.classList.add('is-loaded');

            //Проверяем на ботов
            const obsInput = document.querySelector('[name="obs"]');
            if(obsInput.value.length > 0) form.removeAttribute('action');

            const nameVal = inputName.value.length;
            const phoneVal = inputPhone.value.length;


            // Получаем информацию о товарах из корзины
            const cart = document.querySelector('.cart__product-wrapper');
            
            if(cart) {
                const cartProducts = document.querySelectorAll('.cart__product');
                let productsInfo = '';
            
                cartProducts.forEach(product => {
                    const productName = product.querySelector('.cart__product-title').innerText;
                    const productCount = product.querySelector('.cart__product-count').value;
                    productsInfo += `${productName} - ${productCount}шт. | `;
                });
            
                // Получаем сумму товаров
                const totalSum = document.querySelector('.cart__summ').innerText;
            
                // Записываем информацию о товарах и сумме в инпуты
                document.getElementById('products-name').value = productsInfo.trim();
                document.getElementById('products-sum').value = totalSum;
            }
            

            //Проверяем не пустые ли инпуты и если да, то добавляем класс ошибки
            if (nameVal < 2) inputName.classList.add('error');
            if (phoneVal < 2) inputPhone.classList.add('error');

            
            if(nameVal >= 2 && phoneVal >= 2) {
                //Если инпуты соответствуют проверке удаляем класс ошибки с инпутов при отправке
                inputName.classList.remove('error');
                inputPhone.classList.remove('error');

                //И отправляем запрос на сервер
                const formData = new FormData(form);
                const request = new XMLHttpRequest();

                request.open('POST', action);
                request.send(formData);

                request.addEventListener('load', () => {
                    if (request.status === 200) {
                        const successModal = document.querySelector('.form-success');

                        form.reset();

                        setTimeout(()=>{
                            successModal.classList.add('show');

                            if(document.querySelector('.cart')) {
                                document.querySelector('.cart').classList.remove('show');
                            }

                            form.classList.remove('is-loaded');
                        }, 300);

                        setTimeout(()=>{form.classList.remove('is-loaded')}, 3000);
                        
                        setTimeout(()=> {
                            successModal.classList.remove('show');
                        }, 8000);
                    } else {
                        alert('Что-то пошло не так, попробуйте снова или проверьте подключение к интернету');
                    }
                });
            }
        });
    }
}

export default forms;